import React, { useEffect, useRef, useState, useMemo } from "react";
import { Grid, Typography, Button, Tooltip } from "@mui/material";
import { AlertMessage } from "../../../components/AlertMessage";

//layout import
import Layout from "../../../layout/Layout";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { LoadingButton } from "@mui/lab";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import DoneIcon from "@mui/icons-material/Done";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import IconButton from "@mui/material/IconButton";
import { MaterialReactTable } from "material-react-table";
import dayjs from "dayjs";

// date

import axios from "axios";
import { config, leaveAPI, userData } from "../../../config";

function ApproveLeave() {
  const navigate = useNavigate();
  const childRef = useRef();
  const validationSchema = Yup.object().shape({
    txtLeaveReason: Yup.string().required("Leave Reason is required"),
    txtLeaveSubject: Yup.string().required("Leave Subject is required"),
  });
  const formOptions = { resolver: yupResolver(validationSchema) };
  const { register, handleSubmit, reset, formState, setValue } =
    useForm(formOptions);

  const [positionMasterList, setpositionMasterList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(10);

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [filters, setFilters] = useState([]);
  const [sorting, setSorting] = useState([]);

  let tempRefs = useRef(false);
  useEffect(() => {
    if (tempRefs.current === false) {
      fetchUsers(1);
      tempRefs.current = true;
    }
  }, []);

  const fetchUsers = async () => {
    const data = JSON.stringify({
      pageSize,
      pageIndex,
      intType: 8,
      columnFilters: filters,
      sorting,
    });

    config.method = "POST";
    config.data = data;
    config.url = leaveAPI;
    axios(config)
      .then(function (response) {
        setpositionMasterList(response.data.result);
        setTotalCount(response.data.totalCount);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchUsers();
  }, [pageIndex, pageSize, filters, sorting]);

  const columns = useMemo(
    () => [
      {
        header: "S.No.",
        Cell: ({ row, table }) => {
          const pageIndex = table.getState().pagination.pageIndex;
          const pageSize = table.getState().pagination.pageSize;
          return pageIndex * pageSize + row.index + 1;
        },
        size: 60,
        enableSorting: false,
        enableColumnFilter: false,
      },

      {
        accessorKey: "employee_name",
        header: "Employee Name",
        width: "30%",
        Cell: ({ row }) => {
          const name = row.original.employee_name;
          const employeeNo = row.original.employee_no;
          return <span>{`${name} (${employeeNo})`}</span>;
        },
        enableSorting: false,
      },
      {
        accessorKey: "leave_from_date",
        header: "From Date",
        Cell: ({ cell }) => {
          const rawDate = cell.getValue();
          return dayjs(rawDate).format("DD-MM-YYYY");
        },

        enableColumnFilter: false,
      },
      {
        accessorKey: "leave_to_date",
        header: "To Date",
        Cell: ({ cell }) => {
          const rawDate = cell.getValue();
          return dayjs(rawDate).format("DD-MM-YYYY");
        },

        enableColumnFilter: false,
      },

      {
        accessorKey: "leave_subject",
        header: "Subject",
        Cell: ({ cell }) => (
          <Tooltip title={cell.getValue()} arrow>
            <span>{cell.getValue()}</span>
          </Tooltip>
        ),
        enableSorting: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "action",
        header: "Action",
        enableSorting: false,
        Cell: ({ row }) => {
          const rowData = row.original;
          return (
            <>
              {rowData.leave_status == 84 ? (
                <>
                  <Tooltip title="Accept Leave">
                    <IconButton
                      color="success"
                      onClick={() => handleLeave(rowData.id, 85)}
                    >
                      <DoneIcon />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="Decline Leave">
                    <IconButton
                      color="error"
                      onClick={() => handleLeave(rowData.id, 86)}
                    >
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </>
              ) : rowData.leave_status == 85 ? (
                <Tooltip title="Leave Accepted">
                  <DoneAllIcon color="success" />
                </Tooltip>
              ) : (
                <Tooltip title="Leave Denied">
                  <CloseIcon color="error" />
                </Tooltip>
              )}
            </>
          );
        },
        enableSorting: false,
        enableColumnFilter: false,
      },
    ],
    []
  );

  const handleLeave = (LeaveID, status) => {
    const data = JSON.stringify({
      intType: 3,
      intLeaveID: LeaveID,
      intLeaveStatus: status,
    });

    config.method = "POST";
    config.data = data;
    config.url = leaveAPI;

    axios(config)
      .then(function (response) {
        window.location.reload(false);
        childRef.current.triggerAlert(
          JSON.stringify({
            message: response.data.message,
            messageType: "success",
          })
        );
        window.location.reload();
      })
      .catch(function (error) {
        console.log(error);
        childRef.current.triggerAlert(
          JSON.stringify({
            message: "Something went wrong",
            messageType: "error",
          })
        );
      });
  };

  return (
    <Layout>
      <Grid className="employee-form bold-header">
        <Grid container spacing={3}>
          <Grid
            textAlign="center"
            item
            className="form-lable"
            xs={12}
            lg={6}
            md={6}
          >
            <Typography className="page_title" textAlign="left">
              Leave Approval
            </Typography>
            <Breadcrumbs aria-label="breadcrumb">
              <Link underline="hover" color="inherit" href="/dashboard">
                Dashboard
              </Link>
              <Typography color="text.primary">Leave</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>
        <MaterialReactTable
          columns={columns}
          data={positionMasterList}
          enableGlobalFilter={false}
          enableFullScreenToggle={false}
          enableDensityToggle={false}
          className="mat-react-tbl"
          state={{
            isLoading: loading,
            pagination: { pageIndex, pageSize },
            sorting,
            columnFilters: filters,
          }}
          manualPagination
          manualSorting
          manualFiltering
          rowCount={totalCount}
          onPaginationChange={(updater) => {
            const paginationState = updater({
              pageIndex,
              pageSize,
            });
            const { pageIndex: newPageIndex, pageSize: newPageSize } =
              paginationState;
            setPageIndex(newPageIndex);
            setPageSize(newPageSize);
          }}
          onSortingChange={setSorting}
          onColumnFiltersChange={setFilters}
          muiTableBodyCellProps={{
            sx: {
              padding: "3px 8px",
              border: "1px solid #ccc",
            },
          }}
          muiTableHeadCellProps={{
            sx: {
              "& input": {
                color: "#fff !important",
                "&::placeholder": {
                  color: "#fff !important",
                  opacity: 1,
                },
              },
              "& .MuiSelect-select": {
                color: "#fff !important", // selected text color
              },
              "& .MuiSelect-icon": {
                color: "#fff !important", // dropdown arrow color
              },
              color: "#fff",
              fontWeight: "bold",
              "& svg": {
                color: "#fff",
              },
              "& .MuiTableSortLabel-root": {
                color: "#495057",
                "&.Mui-active": {
                  color: "#fff",
                  "& .MuiTableSortLabel-icon": {
                    color: "#fff !important",
                  },
                },
              },
              "& .MuiTableSortLabel-icon": {
                color: "#fff !important",
              },
            },
          }}
          muiTableBodyRowProps={({ row }) => ({
            sx: {
              borderBottom: "1px solid #ccc",
              backgroundColor: row.index % 2 === 0 ? "#ffffff" : "#e3f2fd",
            },
          })}
          muiTableHeadCellFilterTextFieldProps={{
            sx: {
              "& input": {
                color: "#fff !important", // Change text color
              },
              "& .MuiInput-underline:before": {
                borderBottomColor: "#fff !important", // Change underline color
              },
              "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                borderBottomColor: "#fff !important", // Hover underline color
              },
              "& .MuiInput-underline:after": {
                borderBottomColor: "#fff !important", // Focused underline color
              },
            },
          }}
        />
      </Grid>
    </Layout>
  );
}
export default ApproveLeave;
